import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import Trans from 'next-translate/Trans'
import { Link } from 'components/Link'
import { Text } from 'components/Text'
import { Stack } from 'components/Stack'
import { TranslationKeys } from 'locales/translationKeys'
import { UnorderedList, OrderedList } from './ParagraphAndList.styles'
import { linkObject } from '../../PrivacyPolicy'

export type ParagraphAndListProps = {
  paragraphs?: TranslationKeys[]
  list?: TranslationKeys[]
  orderedList?: TranslationKeys[]
  links?: linkObject[]
  nestingLevel: number
}

export const ParagraphAndList = ({
  paragraphs,
  list,
  orderedList,
  links,
  nestingLevel,
}: ParagraphAndListProps) => {
  const { t } = useTranslation()

  if (!paragraphs && !list) return null

  const linkComponents = links?.reduce((acc, linkObj) => {
    acc[linkObj.key] = <Link href={linkObj.link} key={linkObj.key} />
    return acc
  }, {} as Record<string, React.ReactElement>)

  return (
    <>
      <Stack direction="column" gap="3">
        {paragraphs &&
          paragraphs?.map((paragraph, index) => {
            return links && links.length > 0 ? (
              <Stack
                key={index}
                css={{
                  display: 'inline',
                  paddingLeft: `${nestingLevel * 24}px`,
                  fontStyle:
                    paragraph === 'terms-and-conditions:general.disclaimer.description-5'
                      ? 'italic'
                      : 'normal',
                }}
              >
                <Trans components={linkComponents} i18nKey={paragraph}></Trans>
              </Stack>
            ) : (
              <div key={index} css={{ paddingLeft: `${nestingLevel * 24}px` }}>
                <Text css={{ paddingLeft: `${nestingLevel * 24}px` }}>{t(paragraph)}</Text>
              </div>
            )
          })}
        {list && (
          <UnorderedList css={{ paddingLeft: `${nestingLevel * 24 + 24}px` }}>
            {list.map((listItem, index) => {
              return (
                <li key={index}>
                  {links && links.length > 0 ? (
                    <Trans components={linkComponents} i18nKey={listItem}></Trans>
                  ) : (
                    t(listItem)
                  )}
                </li>
              )
            })}
          </UnorderedList>
        )}
        {orderedList && (
          <OrderedList
            css={{ paddingLeft: `${nestingLevel * 24 + 24}px`, listStyle: 'decimal !important' }}
          >
            {orderedList.map((listItem, index) => {
              return (
                <li key={index}>
                  {links && links.length > 0 ? (
                    <Trans components={linkComponents} i18nKey={listItem}></Trans>
                  ) : (
                    t(listItem)
                  )}
                </li>
              )
            })}
          </OrderedList>
        )}
      </Stack>
    </>
  )
}

ParagraphAndList.displayName = 'ParagraphAndList'
